export async function fetchPreviewQuestions(id) {
  var url = `/v1/api/preview-questions/${id}`
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + url,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function fetchMilestoneStatus(id) {
  var url = `/v1/api/fetch-milestone-status/${id}`
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + url,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}
